import { getCategoryThemes } from '#web-oura-tools/theme/themes'
import type { CATEGORY_THEMES, ThemeColors } from '#web-oura-tools/theme/themes'

export interface VuetifyThemeDefinition {
  dark: boolean
  colors: ThemeColors
  variables?: Record<string, string | number>
}

export interface VuetifyThemes {
  dark: VuetifyThemeDefinition
  light: VuetifyThemeDefinition
  [name: string]: VuetifyThemeDefinition
}

/**
 * Build light and dark Vuetify themes.
 *
 * @param input - Category name, Material color name, or hex color. Unknown or omitted values fall back to a default color.
 */
export function getVuetifyThemes(input?: keyof typeof CATEGORY_THEMES): VuetifyThemes {
  const variables = { 'high-emphasis-opacity': 1 }

  const themes = getCategoryThemes(input)

  return {
    dark: { dark: true, colors: themes.dark, variables },
    light: { dark: false, colors: themes.light, variables },
  }
}
